/*
 * ChasingCards — Scroll-Reveal (nur Startseite).
 * Pattern A: .cc-reveal → einfaches Fade+Slide-in (IntersectionObserver, 15 %).
 * Pattern B: .cc-reveal-stagger-group → gestaffelte Kinder (.cc-reveal-stagger),
 *   +80 ms pro Element, max. 8 Slots (= 640 ms max Delay).
 * .js-Klasse auf <html> steuert den CSS-Initialzustand (opacity:0).
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var STEP_MS = 80;
  var CAP = 8;
  var THRESHOLD = 0.15;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;

      if (el.classList.contains('cc-reveal-stagger-group')) {
        var items = Array.prototype.slice.call(
          el.querySelectorAll(':scope > .cc-reveal-stagger')
        );
        items.forEach(function (item, i) {
          item.style.setProperty('--reveal-delay', Math.min(i, CAP) * STEP_MS + 'ms');
          item.classList.add('is-visible');
        });
      } else {
        el.classList.add('is-visible');
      }

      observer.unobserve(el);
    });
  }, { threshold: THRESHOLD });

  document.querySelectorAll('.cc-reveal, .cc-reveal-stagger-group').forEach(function (el) {
    observer.observe(el);
  });
})();
